const initialState = {
    dataTags: false,
    dataTag: false,
    dataTagDatasets: false,
    totResultTags: 0,
    totResultTagDatasets: 0,
}

const tagReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATA_TAGS':
            return { ...state, dataTags: action.payload }
        case 'DATA_TAG':
            return { ...state, dataTag: action.payload }
        case 'DATA_TAG_DATASETS':
            return { ...state, dataTagDatasets: action.payload }
        case 'TOT_RESULT_TAGS':
            return { ...state, totResultTags: action.payload }
        case 'TOT_RESULT_TAG_DATASETS':
            return { ...state, totResultTagDatasets: action.payload }
        default:
            return state
    }
}

export default tagReducer;